import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import { useEffect } from "react";

import { ErrorCause } from "../providers/ApiProvider";
import { ErrorCodeMap } from "../types/Error";
import Alert from "./Alert";

// refresh
const ErrorBoundaryFallback = ({ error }: { error: Error }) => {
  const handleRefresh = () => {
    location.reload();
  };
  const handleHome = () => {
    location.replace("/");
  };

  useEffect(() => {
    const handlePopState = () => {
      window.location.reload();
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  const errorCode = error && (error.cause as ErrorCause)?.errorCode;
  const errorMessage =
    errorCode && ErrorCodeMap[errorCode]
      ? ErrorCodeMap[errorCode]
      : "Oops. Try again. Or call 1800 288 689.";

  return (
    <Container maxWidth={"md"} sx={{ mt: 2 }}>
      <Stack spacing={2}>
        <Alert
          severity="error"
          title={errorMessage}
          message={`<div>${error.message}</div>`}
          asHTML
          detailsExpandable
        />
        <Box
          sx={{
            pt: 2,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box>
            <Button
              size="large"
              color="primary"
              variant="outlined"
              disableElevation={true}
              onClick={() => handleRefresh()}
            >
              Back
            </Button>
          </Box>
          <Box>
            <Button
              size="large"
              color="primary"
              variant="contained"
              disableElevation={true}
              onClick={() => handleHome()}
            >
              Home
            </Button>
          </Box>
        </Box>
      </Stack>
    </Container>
  );
};

export default ErrorBoundaryFallback;
